import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';
import {ActionButtons} from "_components/ActionButtons/ActionButtons";
import {PageCopy} from "_components/PageCopy/PageCopy";
import {PromocracyLogo} from "_components/PromocracyLogo/PromocracyLogo";
import PageFlow from "_pages/__routes/PageFlow";
import {CustomContent} from '_pages/Variations/CustomContent/CustomContent';
import {PageBackgroundImages} from "_components/PageBackgroundImages/PageBackgroundImages";
import {IFrameInsert} from "_components/IFrameInsert/IFrameInsert";

//import { executeAction } from "__globals/appActions";
import * as GC from "__globals/GLOBAL-CONSTANTS";
import { logIt } from '__globals/global-functions';

export const AlreadyPlayed = props => {

	logIt( GC.PAGE_ALREADY_PLAYED + " PAGE IS CALLED", null, false );
	const PAGE_DIV_NAME = "already_played"; // use underscores
	const PAGE_KEY = "alreadyPlayed"; // use camel case
	const PAGE_IMAGE_KEY = "already-played"; // use dashes
	const PAGE_JSON_KEY = GC.PAGE_ALREADY_PLAYED; // use init caps

	//const dispatch = useDispatch();

	const promotion = useSelector(state => state.promotion);
	//logIt( "PROMOTION at " + PAGE_JSON_KEY, promotion, true );

	// LOCAL VARIABLES
	const [action, setAction] = useState('');
	const [value, setValue] = useState('');

	const [goNext, setGoNext] = useState(false);

	const doAction = ( a, v ) => {
		if ( a.toUpperCase().trim() === GC.ACTION_NAVIGATE ) {
			setAction(a);
			setValue(v);
			setGoNext(true);
		} else {
			//dispatch( executeAction(a, v) );
		}
	}

	if (goNext) {

		return (<PageFlow page={GC.PAGE_ALREADY_PLAYED} error={null} action={action} value={value} />);

	} else {

		return (
			<React.Fragment>
				<TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title}/>
				<div id={PAGE_DIV_NAME + "_page"}>

					<table>
						<tbody>
						<tr>
							<td className="page-visual">

								<PageBackgroundImages
									promotion={promotion}
									pageKey={PAGE_IMAGE_KEY}
								/>

							</td>
							<td className="page-content">

								<div id={PAGE_DIV_NAME + "_content"}>

									<PageCopy
										promotion={promotion}
										configKey={PAGE_KEY}
										jsonKey={PAGE_JSON_KEY}
									/>

									<ActionButtons
										promotion={promotion}
										configKey={PAGE_KEY}
										jsonKey={PAGE_JSON_KEY}
										doAction={doAction}
									/>


								</div>

								<PromocracyLogo promotion={promotion} />

								<IFrameInsert
									promotion={promotion}
									configKey={PAGE_KEY}
								/>

							</td>
						</tr>
						</tbody>
					</table>

					<CustomContent/>

				</div>
			</React.Fragment>

		);

	}

}

